<ng-container *ngIf="!baselineOffersLoading(); else loadingTemplate">
  <div class="com-table com-table-appearance" *ngIf="{ disableConfirmButton: (disableConfirmButton$ | async) } as vm">
    <div class="section">
      <div class="section_container">
        <div class="section-filter">
          <span class="section-filter--show"
            >{{ 'COM.CSV.CSV_REG_NAME' | translate }}:
            <h4>
              {{ displaySelectedReg }}
            </h4></span
          >
          <span class="section-filter--show"
            >{{ 'COM.CSV.CSV_DATE_RANGE' | translate }}:
            <h4>{{ dateLabel$ | async }}</h4></span
          >
        </div>
        <div class="section-in-right section-btns">
          <span [matTooltip]="'COM.FILTERS.EDIT_DISABLED' | translate" [matTooltipDisabled]="applyButtonDisabled()" matTooltipPosition="below">
            <button
              *ngIf="!editModeSignal() && showEditButton()"
              [disabled]="!applyButtonDisabled()"
              scrollToTop
              mat-stroked-button
              color="primary"
              data-cy="baselines-tab-edit-btn"
              class="round-button section-btns--edit"
              (click)="triggerEditMode(true)"
            >
              {{ 'COM.BUTTONS.EDIT' | translate }}
            </button>
          </span>
          <button
            *ngIf="editModeSignal()"
            mat-flat-button
            scrollToHeader
            color="primary"
            [disabled]="!vm.disableConfirmButton"
            [ngClass]="{ 'section-btns--confirm--disabled': !vm.disableConfirmButton }"
            data-cy="baselines-tab-confirm-btn"
            class="round-button section-btns--confirm"
            (click)="save()"
          >
            {{ 'COM.BUTTONS.CONFIRM' | translate }}
          </button>
          <button
            *ngIf="editModeSignal()"
            mat-stroked-button
            scrollToHeader
            color="primary"
            data-cy="baselines-tab-cancel-btn"
            class="round-button section-btns--cancel"
            (click)="cancel()"
          >
            {{ 'COM.BUTTONS.CANCEL' | translate }}
          </button>
          <div *ngIf="isBulkImportAllowed()" class="relative-position">
            <button data-cy="baselines-tab-more-options" mat-icon-button (click)="toggleDownloadUploadOptions($event)" class="more-options-btn">
              <mat-icon>more_vert</mat-icon>
            </button>
            <div *ngIf="showDownloadUploadOptionsSignal()" class="download-upload-options" (clickOutside)="clickOutsideDownloadUploadOptions()">
              <button mat-menu-item (click)="openBulkUploadFunctionalityDialog()" class="download-upload-options--option">
                <mat-icon class="download-upload-options--option-icon">upload</mat-icon>
                <span>{{ 'COM.BUTTONS.BULK_UPLOAD' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="section_bulk_offers" *ngIf="editModeSignal()">
        <dr-customer-offers-ui-bulk-offers
          [minDate]="minDate"
          [maxDate]="maxDate"
          [selectedTabOption]="selectedTabSignal()"
          [currentRegViewConfig]="currentRegViewConfig()"
        ></dr-customer-offers-ui-bulk-offers>
      </div>
    </div>

    <div class="com-table_container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [class.mat-mdc-table--spacing]="!editModeSignal()" multiTemplateDataRows>
        <ng-container matColumnDef="offer">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-offer-row">{{ 'COM.LABELS.OFFER_NUM' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="com-table_container--offer-column">
            <b>{{ element.index }}</b>
          </td>
        </ng-container>
        <ng-container matColumnDef="time_period">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-row">{{ 'COM.LABELS.TIME_FRAME' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="com-table_container--time-column">
            <b>{{ { inputTime: element.timePeriodKey, timeGap: currentRegViewConfig()!.intervalFrequency } | mapTime }}</b>
            ({{ timezoneAbbr }})
          </td>
        </ng-container>

        <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef class="com-table_container--header-row">
            <ng-container> {{ column | weekDay }} {{ dates[i] | suffixDate }} </ng-container>
          </th>
          <td mat-cell *matCellDef="let element" class="com-table_container--columns">
            <div [class.com-table_container--columns-readonly]="!editModeSignal()" [class.com-table_container--columns-readonly-last]="i === 6">
              <!-- Readonly mode -->
              <ng-container *ngIf="!editModeSignal(); else editModeRef">
                <div class="td-cell_readonly">
                  <div class="td-cell_readonly-container" [class.td-cell_readonly-container--color]="element[columns[i]].gate_closed">
                    <span class="td-cell_readonly-body td-cell_readonly-body--lock">
                      <dr-customer-offers-ui-icons
                        *ngIf="element[columns[i]].gate_closed"
                        [state]="UIState.GateClosed"
                        name="lock_outlined"
                      ></dr-customer-offers-ui-icons>
                      <dr-customer-offers-ui-icons
                        *ngIf="element[columns[i]].is_dst_add_hr || !element[columns[i]].start_date_time"
                        [isSVG]="true"
                        svgName="sunny.svg"
                      ></dr-customer-offers-ui-icons>
                    </span>
                    <span class="td-cell_readonly-body" [class.td-cell_readonly-body--color]="element[columns[i]].gate_closed">{{
                      element[columns[i]].value
                    }}</span>
                  </div>
                </div>
              </ng-container>
              <!-- /Readonly mode -->
              <!-- Edit Mode -->
              <ng-template #editModeRef>
                <ng-container *ngIf="element[columns[i]].gate_closed">
                  <div class="td-cell--align">
                    <div class="td-cell_readonly">
                      <div class="td-cell_readonly-container" [class.td-cell_readonly-container--color]="element[columns[i]].gate_closed">
                        <span class="td-cell_readonly-body td-cell_readonly-body--lock">
                          <dr-customer-offers-ui-icons
                            *ngIf="element[columns[i]].gate_closed"
                            [state]="UIState.GateClosed"
                            name="lock_outlined"
                          ></dr-customer-offers-ui-icons>
                          <dr-customer-offers-ui-icons
                            *ngIf="element[columns[i]].is_dst_add_hr || !element[columns[i]].start_date_time"
                            [isSVG]="true"
                            svgName="sunny.svg"
                          ></dr-customer-offers-ui-icons>
                        </span>
                        <span class="td-cell_readonly-body" [class.td-cell_readonly-body--color]="element[columns[i]].gate_closed">{{
                          element[columns[i]].value
                        }}</span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="!element[columns[i]].gate_closed">
                  <div class="td-cell--align">
                    <div class="td-cell">
                      <div class="td-cell_custom-input">
                        <div class="td-cell_icons">
                          <dr-customer-offers-ui-icons
                            *ngIf="element[columns[i]].is_dst_add_hr || !element[columns[i]].start_date_time"
                            [isSVG]="true"
                            svgName="sunny.svg"
                          ></dr-customer-offers-ui-icons>
                        </div>
                        <input
                          class="td-cell_input"
                          (wheel)="$event.preventDefault()"
                          type="number"
                          [value]="element[columns[i]].value"
                          (keyup)="inputToCellValue(element, $event, column)"
                          [disabled]="!element[columns[i]].start_date_time"
                        />
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
              <!-- /Edit Mode -->
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div [class.table-element-empty]="editModeSignal()">
              <!-- To maintain spacing between rows on edit mode -->
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-element-row" [class.table-expanded-row]="editModeSignal()"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
      </table>
    </div>

    <div class="com-table_footer">
      <div class="com-table_footer-icon">
        <dr-customer-offers-ui-icons name="lock_outlined"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.GATE_CLOSED' | translate }}</span>
      </div>
      <div class="com-table_footer-icon">
        <dr-customer-offers-ui-icons [isSVG]="true" svgName="beach_access.svg"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.HOLIDAY' | translate }}</span>
      </div>
      <div class="com-table_footer-icon">
        <dr-customer-offers-ui-icons [isSVG]="true" svgName="warning.svg"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.EDIT_INSIDE_GC' | translate }}</span>
      </div>
      <div class="com-table_footer-icon">
        <dr-customer-offers-ui-icons [isSVG]="true" svgName="sunny.svg"></dr-customer-offers-ui-icons>
        <span>{{ 'COM.LEGEND.DAYLIGHT_SAVINGS' | translate }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-page">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
